/**
 * Request permission, register service worker, subscribe with VAPID key, send to backend.
 */
const SW_PATH = "/sw.js";

export async function subscribeToPush(apiBase, vapidPublicKey) {
  if (!("Notification" in window) || !("serviceWorker" in navigator)) return null;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;
  const reg = await navigator.serviceWorker.register(SW_PATH);
  await reg.update();
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  });
  return sub;
}

export function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) output[i] = rawData.charCodeAt(i);
  return output;
}

export async function sendSubscriptionToBackend(apiBase, subscription) {
  const res = await fetch(`${apiBase}/notifications/subscribe`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(subscription.toJSON()),
  });
  if (!res.ok) throw new Error(await res.text());
  return res;
}

export async function unsubscribeFromBackend(apiBase, endpoint) {
  const res = await fetch(`${apiBase}/notifications/unsubscribe`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ endpoint: endpoint || null }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res;
}
